import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Tabs } from '@hpstellar/core';

import { Helpers } from '../../../core/src/helpers';
import useDeviceInfo from '../../../hooks/useDeviceInfo';
import { formatMetricValue } from '../../../metrics/metrics-helpers';
import withPageComponents from '../../../page/components/with-page-components';
import { Link } from 'react-router-dom';
import { omit } from '@hpstellar/utils';
import './sale-page-tabs.less';

const getTabs = (tabs, selectedTab) => {
    let activeIndex = 0;
    const tabContent = tabs.map((t, idx) => {
        const { name = '', identifier } = t;
        if (identifier === selectedTab) {
            activeIndex = idx;
        }
        return {
            tab: {
                title: name,
                gtmValue: formatMetricValue(name),
            },
        };
    });
    return {
        tabContent,
        activeIndex,
    };
};

const getTabLink = tab => {
    const { path, search, tabLink, name } = tab || {};
    const { _preview } = search || {};

    let queryString;
    if (!tabLink) {
        let searchQueryString =
            search &&
            !_preview &&
            Helpers.paramsToString(
                Object.keys(search).reduce((obj, key) => {
                    if (search[key]) obj[key] = search[key];
                    return obj;
                }, {})
            );
        queryString = _preview
            ? `?${Helpers.paramsToString({ _preview })}`
            : searchQueryString && searchQueryString.length > 0
            ? `?${searchQueryString}`
            : '';
    }

    return Helpers.getRelativePath(tabLink || `${path}${queryString || ''}`);
};

const SalePageTabs = ({ tabs, selectedTab, productTab, className, tabsListProps = {} }) => {
    const { tabGtmActions } = productTab || {};
    const { dropdownOnMobile } = tabsListProps || {};
    const { activeIndex, tabContent } = getTabs(tabs, selectedTab);
    const { device } = useDeviceInfo();
    const history = useHistory();

    const tabClick = useCallback(
        index => {
            setTimeout(() => {
                try {
                    document.getElementById('topBanner').scrollIntoView();
                } catch (e) {}
            }, 500);
            if (dropdownOnMobile && device === 'mobile') {
                //mobile tabs renders as dropdown with links so we need to handle the click to route
                const tab = tabs[index];
                const href = getTabLink(tab);
                history.push(href);
            }
        },
        [tabs, device, dropdownOnMobile]
    );

    const renderTab = useCallback(
        props => {
            const { index } = props || {};
            const tab = tabs[index] || {};
            const href = getTabLink(tab);
            const newProps = { ...props, className: props.className + ` slp-tab-${props.index}` };

            return <Link type="button" {...omit(['index'], newProps)} to={href} />;
        },
        [tabs]
    );

    const props = {
        dropdownOnMobile: false,
        activeIndex,
        onClick: tabClick,
        size: device === 'mobile' ? 'small' : 'large',
        gtmActions: tabGtmActions,
        type: 'tertiary',
        renderTab,
        ...tabsListProps,
    };

    return (
        <div className={className} id="slpTabNAV">
            {tabContent.length > 1 && (
                <Tabs id="slpTabs" list={tabContent} activeIndex={activeIndex} tabsListProps={props} />
            )}
        </div>
    );
};

export default withPageComponents(SalePageTabs, { components: ['productTab'] });
